import { TooltipBase } from "@frontend/common";
import { splitMultipleStringList } from "@frontend/common/src/business/DatabaseTable/utils/splitMultipleStringList";

import * as S from "./MultipleBulletCell.style";

const EMPTY_VALUE = "-";

// "__" 로 들어오는 멀티값을 split (DES Regulatory labelId/company 동일 처리)
export const getMultipleBulletItems = (value?: string | null) =>
  value ? splitMultipleStringList(value).filter(Boolean) : [];

// 셀(td)에서 hover 툴팁 스타일을 줄지 판단 (visibleCount 초과 시 +N 툴팁 노출)
export const hasMultipleBulletTooltip = (
  value?: string | null,
  visibleCount = 2,
) =>
  !!value?.includes("__") &&
  getMultipleBulletItems(value).length > visibleCount;

interface Props {
  value?: string | null;
  visibleCount?: number;
}

const renderBulletList = (items: string[]) => (
  <S.BulletList>
    {items.map((item) => (
      <S.BulletItem key={item}>
        <S.BulletItemText>{item}</S.BulletItemText>
      </S.BulletItem>
    ))}
  </S.BulletList>
);

/**
 * "__" 로 구분된 멀티값을 불렛으로 표출.
 * - 단일값(구분자 없음)은 그대로 텍스트
 * - visibleCount(기본 2) 개까지 노출하고 초과분은 +N + hover 툴팁(전체 목록)
 * 부모 td 는 position: relative 와 `&:hover .tooltip-wrapper { display: block }` 필요
 */
const MultipleBulletCell = ({ value, visibleCount = 2 }: Props) => {
  if (!value) return <>{EMPTY_VALUE}</>;
  if (!value.includes("__")) return <>{value}</>;

  const items = getMultipleBulletItems(value);
  if (items.length === 0) return <>{EMPTY_VALUE}</>;

  const visibleItems = items.slice(0, visibleCount);
  const remainingCount =
    items.length > visibleCount ? items.length - visibleCount : 0;

  return (
    <>
      {renderBulletList(visibleItems)}

      {remainingCount > 0 && <S.Number>+{remainingCount}</S.Number>}

      {remainingCount > 0 && (
        <S.TooltipWrapper className="tooltip-wrapper">
          <TooltipBase className="tooltip">
            {renderBulletList(items)}
          </TooltipBase>
        </S.TooltipWrapper>
      )}
    </>
  );
};

export default MultipleBulletCell;
